/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_RetryInputs */

const en_backend_session_retry = /** @type {(inputs: Backend_Session_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const fr_backend_session_retry = /** @type {(inputs: Backend_Session_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const ms_sg2_backend_session_retry = /** @type {(inputs: Backend_Session_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba semula`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Backend_Session_RetryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_retry = /** @type {((inputs?: Backend_Session_RetryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_RetryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_retry(inputs)
	if (locale === "fr") return fr_backend_session_retry(inputs)
	return ms_sg2_backend_session_retry(inputs)
});